import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import CustomDatePicker from '@shared/components/CustomDatePicker';

/**
 * @typedef {object} FormDatePickerOwnProps
 * @property {string} name
 */

/**
 * @typedef {FormDatePickerOwnProps & React.ComponentProps<typeof CustomDatePicker>} FormDatePickerProps
 */

/**
 * @param {FormDatePickerProps} props
 */
const FormDatePicker = props => {
  const { name, ...otherProps } = props;
  const {
    control,
    formState: { errors }
  } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <CustomDatePicker
          selectedDate={field.value}
          setSelectedDate={field.onChange}
          hasDateError={!!errors[name]}
          {...otherProps}
        />
      )}
    />
  );
};

export default FormDatePicker;
